<div class="container-filtre">
  <div class="title-modal">
    <span>Filtros</span>
    <span  class="close" (click)="close()">x</span>
  </div>
  <div class="filtros">
    <span>Fecha Inicio</span>
    <ion-item class="input-date">
      <ion-input type="date" [value]="'2022-02-10'" [(ngModel)]="filters.startDate"></ion-input>
    </ion-item>
    <span>Fecha Fin</span>
    <ion-item class="input-date">
      <ion-input type="date" [value]="'2023-02-10'" [(ngModel)]="filters.endDate"></ion-input>
    </ion-item>

    <ion-item class="select">
      <ion-label fill="outline">Tipo :</ion-label>
      <ion-select interface="popover" [(ngModel)]="filters.type">
        <ion-select-option [value]="0" >Todos</ion-select-option>
        <ion-select-option [value]="item.id" *ngFor="let item of alertTypes">{{item.name}}</ion-select-option>
        
      </ion-select>
    </ion-item>

    <ion-item class="select ">
      <ion-label fill="outline">Estado :</ion-label>
      <ion-select interface="popover" [(ngModel)]="filters.state">
        <ion-select-option [value]="''" >Todos</ion-select-option>
        <ion-select-option [value]="item" *ngFor="let item of status">{{item}}</ion-select-option>
        
      </ion-select>
    </ion-item>
  </div>
  <div class="container-button">
    <div>
      <ion-button color="secondary" fill="outline" (click)="close()">Cancelar</ion-button>
      <ion-button color="secondary" (click)="confirm()">Filtrar</ion-button>
    </div>
  </div>
</div>